import React from "react";
import useStyles from './styles';

import CheckIcon from '@material-ui/icons/Check';
import DoneAllIcon from '@material-ui/icons/DoneAll';

const Status = ({type}) => {
    
    const classes = useStyles();
    
    let icon = "";

    switch (type){
        case 'sent': icon = <CheckIcon />; 
            break;
        case 'received': icon = <DoneAllIcon />; 
            break;
        case 'read': icon = <DoneAllIcon className={classes.blue} />; 
            break;
        default: icon = '';
    }

    return (
        <div className={classes.container}>
            {icon}
        </div>
    );
}

export default Status;